"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var SubscribeSave_1 = require("../components/ShopAll/SubscribeSave");
var targetNode = document.querySelector('.subscribe-save-shop-section');
if (targetNode && window.shopBundleProducts && window.shopSubProducts) {
    (0, preact_1.render)((0, preact_1.h)(SubscribeSave_1.default, { shopBundleProducts: window.shopBundleProducts, shopSubProducts: window.shopSubProducts }), targetNode);
}
